import { useMemo } from 'react';
import { usePathname } from 'src/routes/hooks';
import { useGetCustomizePageBySlugQuery } from 'src/store/Reducer/customize-pages';
import { getMarketingSlug, resolveContactUsHref } from 'src/utils/contact-us';

/**
 * Returns the Contact Us href for the current page context.
 * On a marketing page with contact enabled, scrolls to the section;
 * otherwise navigates to the Contact Us screen.
 */
export default function useContactUsHref() {
  const pathname = usePathname();
  // const slug = getMarketingSlug(pathname);
  const slug ='main-page';

  const { data } = useGetCustomizePageBySlugQuery(
    { slug },
    { skip: !slug }
  );
  const isContactEnabled = Boolean(data?.body?.contact_us_enabled);

  return useMemo(
    () => resolveContactUsHref({ pathname, isContactEnabled }),
    [pathname, isContactEnabled]
  );
}
